module.exports = __webpack_public_path__ + "img/skype.2a19e28b.svg";